<template>
  <div class="home-view">
    <main class="home-main">
      <HomeSection id="home" />
      <ProductsSection id="products" />
      <TeamSection id="team" />
      <AboutSection id="about" />
    </main>

    <footer class="footer">
      <div class="footer-container">
        <div class="footer-grid">
          <div class="footer-column brand-column">
            <div class="footer-brand-header">
              <span class="footer-brand-text">AutoSquare</span>
            </div>
            <p class="brand-description">致力于突破地质工程边界，用数字化技术重新定义行业标准。</p>
            <div class="social-links">
              <!-- Placeholder social icons/links if needed later -->
            </div>
          </div>

          <div class="footer-column">
            <h4 class="column-title">产品与服务</h4>
            <ul class="footer-links">
              <template v-if="!footerLoading">
                <li v-for="link in footerLinks" :key="`${link.id}-${link.label}`">
                  <a
                    :href="link.href"
                    :target="link.open_in_new_tab ? '_blank' : undefined"
                    :rel="link.open_in_new_tab ? 'noopener noreferrer' : undefined"
                  >{{ link.label }}</a>
                </li>
              </template>
              <li v-else>加载中…</li>
              <li v-if="!footerLoading && footerLinks.length === 0">暂无链接</li>
            </ul>
          </div>

          <div class="footer-column contact-column">
            <h4 class="column-title">联系我们</h4>
            <div class="footer-contact-grid">
              <div class="contact-item">
                <span class="contact-label">地址</span>
                <div class="contact-value address-group">
                  <span>吉林省长春市朝阳区西民主大街938号</span>
                  <span>河北省石家庄市桥西区裕华东路49号</span>
                </div>
              </div>

              <div class="contact-item">
                <span class="contact-label">邮箱</span>
                <div class="contact-value address-group">
                  <span>zhang_wen@jlu.edu.cn</span>
                  <span>juncheng25@mails.jlu.edu.cn</span>
                </div>
              </div>

              <div class="contact-item large-span">
                <span class="contact-label">信息管理和技术支持</span>
                <a href="http://www.jluzhanggroup.cn/" target="_blank" rel="noopener"
                  class="contact-value instructor-link">吉林大学建设工程学院张文教授课题组</a>
              </div>

              <div class="contact-item">
                <span class="contact-label">服务时间</span>
                <div class="contact-value">周一至周五 9:00 - 18:00</div>
              </div>
            </div>
          </div>
        </div>

        <div class="footer-bottom">
          <div class="footer-bottom-content">
            <p class="copyright">Copyright &copy; 2026 AutoSquare 版权所有.</p>
            <div class="legal-badge-group">
              <a href="https://beian.mps.gov.cn/#/query/webSearch" target="_blank" rel="noopener" class="legal-link gongan-flex">
                <img src="../assets/gongan-icon.png" alt="公安备案图标" class="mini-gongan-icon" />
                <span>吉公网安备22010402001392号</span>
              </a>
              <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener" class="legal-link">
                冀ICP备2026005731号-1
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import axios from 'axios'
import HomeSection from '../components/HomeSection.vue'
import ProductsSection from '../components/ProductsSection.vue'
import TeamSection from '../components/TeamSection.vue'
import AboutSection from '../components/AboutSection.vue'

export default {
  name: 'HomeView',
  components: {
    HomeSection,
    ProductsSection,
    TeamSection,
    AboutSection
  },
  data() {
    return {
      footerLinks: [],
      footerLoading: true,
    };
  },
  mounted() {
    this.fetchFooterLinks();
  },
  methods: {
    async fetchFooterLinks() {
      try {
        const response = await axios.get('/api/footer-links/');
        this.footerLinks = Array.isArray(response.data) ? response.data : [];
      } catch (error) {
        console.error('Error fetching footer links:', error);
        this.footerLinks = [];
      } finally {
        this.footerLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.home-main {
  width: 100%;
}

:deep(section) {
  min-height: 100vh;
  padding: calc(var(--nav-height) + 2rem) 5% 4rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

:deep(.section-container) {
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
}

:deep(.section-title) {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 3rem;
  text-align: center;
  color: var(--text-primary);
  position: relative;
}

:deep(.section-title::after) {
  content: '';
  position: absolute;
  width: 60px;
  height: 4px;
  background-color: var(--accent-color);
  bottom: -15px;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 2px;
}

.footer {
  background-color: #020617;
  color: #f8fafc;
  padding: 5rem 5% 2rem;
  margin-top: auto;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
}

.footer-container {
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
}

.footer-grid {
  display: grid;
  grid-template-columns: 1.1fr 0.8fr 2.6fr;
  /* 给予联系信息更多空间 */
  gap: 4rem;
  margin-bottom: 5rem;
}

.contact-column {
  max-width: none;
}

.footer-contact-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
}

.contact-item {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}

.contact-item.large-span {
  grid-column: 1 / -1;
  /* 让长标签项占据整行 */
}

.contact-label {
  color: #64748b;
  /* Slate 500 */
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  opacity: 0.8;
}

.contact-value {
  color: #cbd5e1;
  font-size: 0.95rem;
  line-height: 1.6;
  word-break: break-all;
  /* 防止长字符串溢出 */
}

.instructor-link {
  text-decoration: none;
  transition: all 0.3s ease;
}

.instructor-link:hover {
  color: var(--accent-color);
  text-decoration: underline;
}

.address-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.brand-column {
  max-width: 400px;
}

.footer-brand-header {
  display: flex;
  align-items: center;
  margin-bottom: 1.2rem;
}

.footer-brand-text {
  font-size: 1.5rem;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: #ffffff;
}

.brand-description {
  color: #94a3b8;
  /* Slate 400 */
  font-size: 0.95rem;
  line-height: 1.7;
}

.column-title {
  font-size: 0.9rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 1.8rem;
  color: #ffffff;
}

.footer-links {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-links li {
  margin-bottom: 0.8rem;
}

.footer-links a {
  color: #94a3b8;
  text-decoration: none;
  transition: all 0.3s ease;
  font-size: 0.95rem;
}

.footer-links a:hover {
  color: var(--accent-color);
  padding-left: 4px;
}

.footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  padding-top: 2rem;
}

.footer-bottom-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1.5rem;
}

.copyright {
  color: #64748b;
  font-size: 0.85rem;
}

.legal-badge-group {
  display: flex;
  gap: 1.5rem;
  align-items: center;
}

.legal-link {
  color: #64748b;
  text-decoration: none;
  font-size: 0.85rem;
  transition: color 0.3s ease;
}

.legal-link:hover {
  color: #cbd5e1;
}

.gongan-flex {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  line-height: 1;
}

.mini-gongan-icon {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

@media (max-width: 992px) {
  .footer-grid {
    grid-template-columns: 1fr 1fr;
    gap: 3rem;
  }
}

@media (max-width: 640px) {
  .footer-grid {
    grid-template-columns: 1fr;
    gap: 2.5rem;
  }

  .footer-bottom-content {
    flex-direction: column;
    align-items: flex-start;
  }

  .legal-badge-group {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }
}

@media (max-width: 768px) {
  .footer-contact-grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
}


</style>
